const key = "cart"

export function selectCart(state) {
  return state[key]
}

export function selectCartId(state) {
  return selectCart(state).id
}
